/**
 * Shared Japa Compass results: just enough to show at a glance, carried in the link itself (nothing is stored).
 *   https://okjapa.com/japa-compass/?r=CA73-IE-US   = best match Canada at 73/100, then Ireland and the United States
 * Used by the quiz on okjapa.com (after the quiz, and when someone opens a shared link) and by Voucha's results page.
 */

/** The link for a best match ({code, match}) and the next countries' codes */
export function shareLink(base, top, next) {
  const codes = (next || []).slice(0, 2).map(c => String(c).toUpperCase());
  const r = String(top.code).toUpperCase() + Math.round(top.match) + (codes.length ? '-' + codes.join('-') : '');
  return String(base).split('?')[0].split('#')[0] + '?r=' + r;
}

/** Reads ?r= back; null if it's missing or not in the expected form */
export function readShared(search) {
  let r = null;
  try {
    r = new URLSearchParams(search).get('r');
  } catch (e) {}
  const m = /^([A-Z]{2})(\d{1,3})((?:-[A-Z]{2}){0,2})$/.exec(String(r || '').toUpperCase());
  if (!m || Number(m[2]) > 100) return null;
  return {
    code: m[1],
    match: Number(m[2]),
    next: m[3] ? m[3].slice(1).split('-') : []
  };
}

/** The words that go with the link when it's shared */
export function shareText(name, match) {
  return 'My Japa Compass best match is ' + name + ' (' + match + '/100). Which country fits you best?';
}

/**
 * Opens the phone's own share sheet where there is one; otherwise returns false so the page can show its
 * WhatsApp and Copy link buttons instead.
 */
export async function nativeShare(title, text, url) {
  if (!navigator.share) return false;
  try {
    await navigator.share({
      title,
      text,
      url
    });
  } catch (e) {
    // closing the share sheet is not an error
  }
  return true;
}
export function whatsappUrl(text, url) {
  return 'https://wa.me/?text=' + encodeURIComponent(text + ' ' + url);
}
export async function copyText(text) {
  try {
    await navigator.clipboard.writeText(text);
    return true;
  } catch (e) {
    return false;
  }
}
flarum.reg.add('voucha-assessments', 'common/share', { shareLink: shareLink,readShared: readShared,shareText: shareText,whatsappUrl: whatsappUrl, });